<template>
  <cumulus-edit-form
    ref="form"
    :icon="icon"
    :title="title"
    :new-item="new_item"
    :can-delete="false"
    @escape="escape"
    @save="save"
  >
    <template v-slot:editform>
      <v-row justify="center">
        <v-col
          cols="12"
          md="8"
        >
          <edit-form
            :user="edited_item"
          />
        </v-col>
        <default-settings v-if="false" />
        <v-col
          cols="12"
          md="4"
        >
          <app-card class="mt-4 text-center">
            <v-card-text class="text-center">
              <h6 class="text-h6 mb-2 text--secondary">
                {{ $t('fields.profile_avatar') }}
              </h6>
              <v-img
                v-if="edited_item.avatar"
                max-height="250px"
                contain
                :lazy-src="'data:image/jpeg;base64,' + edited_item.avatar.thumbnail"
                :src="dataUrl"
              />
              <upload-files
                filter="avatar"
                source-type="avatar"
                class="mt-2"
                @success="uploaded"
              />
            </v-card-text>
          </app-card>
        </v-col>
      </v-row>
    </template>
  </cumulus-edit-form>
</template>

<script>
  // Utilities
  import { call } from 'vuex-pathify'
  import UploadFiles from '@/components/UploadFiles'

  export default {
    name: 'UserEdit',
    components: {
      UploadFiles,
      EditForm: () => import('@/layouts/default/edit/User'),
      DefaultSettings: () => import('@/layouts/default/Settings'),
    },
    data: function () {
      return {
        icon: '$user',
        title: 'profile_datas',
        edited_item_id: -1,
        edited_item: {},
        loading: false,
        prevRoute: '',
        saved: false,
      }
    },
    computed: {
      new_item () { return this.edited_item_id === -1 },
      dataUrl () { return process.env.VUE_APP_API_URL + '/api/storage/avatar/' + this.edited_item.photo_id },
    },
    mounted () {
      this.fetch()
    },
    methods: {
      fetchEditedItem: call('profile/fetch'),
      updateEditedItem: call('profile/update'),
      refreshProfile: call('auth/refreshProfile'),
      async fetch () {
        this.edited_item_id = parseInt(this.$route.params.id)
        this.loading = true
        if (!this.new_item) {
          this.fetchEditedItem({ id: this.edited_item_id }).then(response => {
            this.edited_item = response
            console.log(this.dataUrl)
            this.loading = false
          })
        }
      },
      async save () {
        try {
          this.loading = true
          await this.updateEditedItem(
            this.edited_item,
          ).then(response => {
            this.refreshProfile()
            this.escape()
          }).catch(e => {
            console.log(e)
            this.loading = false
            this.$refs.form.setErrors(e)
          })
        } catch (e) {
          /* this.$buefy.notification.open({
            message: this.$t('app.error.general'),
            type: 'is-danger',
          }) */
        }
      },
      escape () {
        this.$router.push(this.prevRoute.path).catch(() => {})
      },
      uploaded (response) {
        this.edited_item.photo_id = response.id
        console.log(response.id)
      },
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        vm.prevRoute = from
      })
    },
  }
</script>
